import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import React, { PropsWithChildren } from "react"
import { Grid } from "@material-ui/core"
import CheckIcon from "../../assets/images/icon/CheckIcon"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& svg": {
        marginRight: 4,
      },
    },
    text: {
      width: "85%",
      margin: 0,
      color: "#2684FF",
      fontSize: 13,
      fontWeight: 700,
      [theme.breakpoints.up("md")]: {
        fontSize: 17,
      },
    },
  })
)
export default function TypographyWithCheck({ children }: PropsWithChildren<{}>) {
  const classes = useStyles()
  return (
    <Grid className={classes.root} container alignItems={"center"}>
      <CheckIcon />
      <div className={classes.text}>{children}</div>
    </Grid>
  )
}
